export function downloadFile(fileName: string, data: Blob) {
    const link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = URL.createObjectURL(data);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
}
